<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' class="header"></Header>
    <div class="content">
       <Ckbanner></Ckbanner>
       <Ckanalyse></Ckanalyse>
       <Income></Income>
       <Cktable></Cktable>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Ckbanner from '@/components/ck/ckbanner'
import Ckanalyse from '@/components/ck/ckanalyse'
import Income from '@/components/ck/income'
import Cktable from '@/components/ck/cktable'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Ck',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'ck'
    }
  },
  components: {
    Header,
    Ckbanner,
    Ckanalyse,
    Income,
    Cktable,
    Footer
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin-top: 120px;
  min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/components/ck/Ck.vue